import React from 'react';
import { Button, Form } from 'semantic-ui-react';

export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            durationYear: '',
            durationSemester: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.getStudyProgramName = this.getStudyProgramName.bind(this);
    }
    onFilterData() {
        this.props.onFilterData(
            this.getStudyProgramName(this.state.name),
            this.state.durationYear,
            this.state.durationSemester
        );
    }

    getStudyProgramName(id) {
        const { studyPrograms } = this.props;
        const selected = studyPrograms.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <br/>
                <Form>
                    <Form.Group widths="equal" clearing>
                        <Form.Field>
                            <label>{this.props.longTitle ? 'Odsjek | studijski program | ciklus' : 'Naziv studijskog programa'}</label>
                            <Form.Dropdown clearable
                                selection
                                placeholder="Odaberite studijski program"
                                value={this.state.name}
                                onChange={this.handleInputChange}
                                name="name"
                                options={this.props.studyPrograms}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Trajanje (godine)</label>
                            <input
                                value={this.state.durationYear}
                                onChange={(e) => this.setState({ durationYear: e.target.value })}
                                name="durationYear"
                                placeholder="Unesite broj godina"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Trajanje (semestri)</label>
                            <input
                                value={this.state.durationSemester}
                                onChange={(e) => this.setState({ durationSemester: e.target.value })}
                                name="durationSemester"
                                placeholder="Unesite broj semestara"
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button floated="right" basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button floated="right" color="blue" onClick={this.onFilterData}>Filtriraj
                    </Button>
                    <br/>
                </Form>
                <br/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentEnroll/StudyProgramsFilter.js